<script>
  import { fade, fly } from "svelte/transition";
  import ColorFamilyPaletteGenerator from "./ColorFamilyPaletteGenerator.svelte";

  export let color = "";

  let showPopup = false;

  let modal;
</script>

<div class="shade-container">
  <span
    class="shade"
    on:click={() => {
      modal.setAttribute("style", "display:block");
      showPopup = true;
    }}
    style="background-color: {color} ;cursor:pointer;"
  />
  <span class="shade-text" style="font-size: .8rem;">{color.toUpperCase()}</span
  >
  <a
    href="#"
    class="copy-icon"
    on:click={() => {
      const cb = navigator.clipboard;
      cb.writeText(color).then(() => alert("Color copied"));
    }}
  />
</div>

<div
  class="modal"
  transition:fly
  bind:this={modal}
  on:click={() => {
    modal.setAttribute("style", "display:none");

    showPopup = false;
  }}
>
  <div transition:fly class="modal-content">
    <span
      class="close"
      on:click={() => {
        modal.setAttribute("style", "display:none");
        showPopup = false;
      }}>&times;</span
    >
    <ColorFamilyPaletteGenerator groupColor={color} />
  </div>
</div>

<style>
  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default*/
    position: fixed; /* Stay in place */
    z-index: 1111; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 19% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 50%; /* Could be more or less, depending on screen size */
  }
  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }

  div.shade-container {
    display: flex;
    flex-direction: column;
    width: 70px;
    height: 80px;
    border: 1px solid gray;
    margin: 3px;
  }
  span.shade {
    display: block;
    width: 100%;
    height: 55%;
  }
  span.shade:hover {
    -webkit-box-shadow: inset 0px 2px 2px 2px rgba(50, 50, 50, 0.6);
    -moz-box-shadow: inset 0px 2px 2px 2px rgba(210, 204, 204, 0.6);
    box-shadow: inset 0px 2px 2px 2px rgba(50, 50, 50, 0.6);
  }
  span.shade-text {
    display: block;
    /* width: 100%; */
    height: 20%;
    border-top: 3px outset gray;
    text-align: center;
    color: #fff;
    background-color: #000;
    /* font-size: 0.8rem;
    font-family: "Gothic A1", sans-serif; */
  }

  .copy-icon {
    width: 16px;
    height: 20px;
    background-color: lightgray;
    background-image: url(copy.png);
    background-size: cover;
    margin: 6px auto;
  }
</style>
